export default "__VITE_ASSET__Bem9NH5a__"